import { render } from "./z-dropdown-menu.vue?vue&type=template&id=9b70258e&scoped=true&lang=pug"
import script from "./z-dropdown-menu.vue?vue&type=script&lang=js"
export * from "./z-dropdown-menu.vue?vue&type=script&lang=js"

import "./z-dropdown-menu.vue?vue&type=style&index=0&id=9b70258e&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b70258e"]])

export default __exports__